import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const AdminNav = () => {
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('bandcam_admin_token');
    window.location.href = '/admin/login';
  };

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const navItems = [
    { path: '/admin/dashboard', label: 'Dashboard' },
    { path: '/admin/bands', label: 'Bands' },
    { path: '/admin/orders', label: 'Orders' },
    { path: '/admin/schools', label: 'Schools' },
    { path: '/admin/issues', label: 'Issues' },
    { path: '/admin/applications', label: 'Applications' },
    { path: '/admin/blog', label: 'Blog' }
  ];

  return (
    <nav className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <div className="flex space-x-8 py-4">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`${
                  isActive(item.path)
                    ? 'text-indigo-600 border-b-2 border-indigo-600'
                    : 'text-gray-500 hover:text-gray-700'
                } py-2 px-1 text-sm font-medium`}
              >
                {item.label}
              </Link>
            ))}
          </div>
          <button
            onClick={handleLogout}
            className="text-gray-500 hover:text-gray-700 py-2 px-4 text-sm font-medium"
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default AdminNav;

